module.exports = " <h3 class=\"m-top m-bottom\"><a ng-href=\"{{$ctrl.LINKS}}?id={{$ctrl.titleId}}\">{{$ctrl.title}}</a></h3> <div class=hierarchy-wrap> <ul ng-show=$ctrl.breadcrumbs class=no-bullet> <li class=\"aui-breadcrumbs__item {{i}}\" ng-repeat=\"bc in $ctrl.breadcrumbs\" ng-style=\"{'margin-left': 10*$index+'px'}\"> <i class=\"glyphicon glyphicon-chevron-right\"></i> <a ng-href=\"{{$ctrl.LINKS}}?id={{bc.id}}\">{{bc.preferred_label}}</a> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/breadcrumbs/breadcrumbs.html
// module id = 41
// module chunks = 2